<div class="wrapper-content event-header wow slideInDown" *ngIf="cont" data-wow-delay="0.5s"
  style="margin-bottom: 20px;">
  <div class="event-panel left ">
    <img class="event-portrait" alt="{{cont.altimage}}" src="{{api.getImageUrl(cont.image)}}" alt="">
  </div>
  <div class="event-panel right">
    <div class="panel-box-top">
      <div class="event-description">
        <h4>{{cont.webcontext?.title.es}}</h4>
        <h1>{{cont.title?.es}}</h1>
        <div [innerHTML]="cont.content?.es"></div>
        <a class="btn-theme ts-background-4" (click)="printContent()">Descargar / Imprimir</a>
      </div>
    </div>
    <app-share [class]="'dark'" [name]="cont.title?.es"></app-share>
  </div>
</div>



<div class="wrapper-content-fitted" *ngIf="cont">
  <div class="bosni-material" >
    <h3 class="text-center">Objetivo holístico</h3>
    <p>
      <span class="bosni-bullet ts-background-3"></span>Ser
      <span class="bosni-bullet ts-background-4"></span>Saber
      <span class="bosni-bullet ts-background-5"></span>Hacer
      <span class="bosni-bullet ts-background-6"></span>Decidir
    </p>
    <p>
      <span class="ts-color-3">{{cont.custom_text2}} </span>
      <span class="ts-color-4">{{cont.custom_text3}} </span>
      <span class="ts-color-5">{{cont.custom_text4}} </span>
      <span class="ts-color-6">{{cont.custom_text5}} </span>
    </p>
  </div>
  <div class="bosni-material" >
    <h3 class="text-center">Materiales</h3>
    <div [innerHTML]="cont.custom_text1"></div>
  </div>
</div>

<!-- <div class="wrapper-content-fitted" *ngIf="cont">
  <div class="wrapper-header" style="padding-top: 50px;">

    <h1 class="text-center">{{cont.title?.es}}</h1>
  </div>
</div>
 -->
<!---->
<app-widgets #child *ngIf="cont" [data]="cont"></app-widgets>
<app-footer  *ngIf="cont"></app-footer>
